import { Switch } from '@headlessui/react';
import { useState } from 'react';
import { classNames } from 'utils/common';

const Toggle = ({
  label,
  checked = false,
  onChange,
  disabled = false,
}: {
  label?: string;
  checked?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) => {
  const [_checked, setChecked] = useState(checked);

  return (
    <Switch.Group as="div" className="flex items-center" data-testid="switch-group">
      <Switch
        data-testid="switch-button"
        checked={_checked}
        onChange={() => /* istanbul ignore next */ {
          if (!disabled) {
            setChecked(!_checked);
            onChange(!_checked);
          }
        }}
        className={classNames(
          _checked ? 'bg-green-500' : 'bg-gray-200',
          'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            _checked ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
          )}
        />
      </Switch>
      {label && (
        <Switch.Label as="span" className="ml-3" data-testid="switch-label">
          <span className="text-sm font-medium text-gray-900">{label}</span>
        </Switch.Label>
      )}
    </Switch.Group>
  );
};

export default Toggle;
